import React from 'react'
import { Col, Row } from 'react-flexbox-grid'
import { withRouter } from 'react-router-dom'
import * as Constants from '../../../constants'
import { Button, Checkbox, Form, Input, InputNumber } from 'antd'
import './styles.css'

const FormToolInventory = (props) => {
    const { loading, onSubmitToolInventory, onBack, isEditing, toolInventoryToEdit } = props
    const [form] = Form.useForm()

    const handleSubmit = values => {
        if (isEditing && toolInventoryToEdit) {
            const obj = {
                id: toolInventoryToEdit.id,
                name: values.name,
                enabled: values.enabled,
                generalInformation: values.generalInformation ?? null,
                type: Constants.INVENTORY_TYPES.TOOL
            }
            onSubmitToolInventory(obj)
        } else {
            const obj = {
                name: values.name,
                enabled: values.enabled,
                generalInformation: values.generalInformation ?? null,
                type: Constants.INVENTORY_TYPES.TOOL
            }
            onSubmitToolInventory(obj)
        }
    }

    const handleReset = () => {
        form.resetFields()
    }

    const getInitialValuesFromToolInventory = () => {
        return {
            name: toolInventoryToEdit.name,
            enabled: toolInventoryToEdit.enabled,
            generalInformation: toolInventoryToEdit.generalInformation ?? null
        }
    }

    return (
        <Form onFinish={handleSubmit} form={form}
              initialValues={isEditing && getInitialValuesFromToolInventory()}>
            <Row>
                <Col xs={12} md={6}>
                    <Form.Item name="name" rules={[{
                        required: true,
                        message: 'Por favor, ingresa el nombre de la herramienta'
                    }]}>
                        <Input placeholder="Nombre"/>
                    </Form.Item>
                </Col>
                <Col xs={12} md={6}>
                    <Form.Item name="generalInformation">
                        <Input placeholder="Información"/>
                    </Form.Item>
                </Col>
            </Row>
            <Row center="xs">
                <Col xs={12}>
                    <Form.Item name="enabled" valuePropName="checked" initialValue={true}>
                        <Checkbox>Habilitado</Checkbox>
                    </Form.Item>
                </Col>
            </Row>
            <Row center="xs">
                <Col xs={12} sm={6} md={3}>
                    <Button className="buttonFormToolInventory" type="primary" htmlType="submit" loading={loading}>
                        Cargar
                    </Button>
                </Col>
                <Col xs={12} sm={6} md={3}>
                    <Button className="buttonFormToolInventory" onClick={handleReset} loading={loading}>
                        {isEditing ? 'Restablecer' : 'Limpiar'}
                    </Button>
                </Col>
            </Row>
            <Row center="xs">
                <Col xs={12} sm={6} md={3}>
                    <Button className="buttonFormToolInventory" onClick={onBack}
                            loading={loading}>
                        Salir
                    </Button>
                </Col>
            </Row>
        </Form>
    )
}

export default withRouter(FormToolInventory)
